import React, { useState } from 'react';
import ContainerSearchField from './ContainerSearchField';

export default function NextContainerSearch({
  options,
  onSearchContainer,
  onSelectContainer,
}) {
  const [searchValue, setSearchValue] = useState('');

  return (
    <ContainerSearchField
      variant="autocomplete"
      value={searchValue}
      onChange={setSearchValue}
      onSubmitSearch={onSearchContainer}
      onSelectOption={onSelectContainer}
      options={options}
      accentColor="primary"
    />
  );
}
